import React from 'react';
import PropTypes from 'prop-types';

import {
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from '@material-ui/core';
import ArrowIcon from '@material-ui/icons/ArrowForwardIos';
import CreditCardIcon from '@material-ui/icons/CreditCard';

import { useStyles } from './styles';

const PaymentItem = ({ valor, formaPagamento, onClick }) => {
  const classes = useStyles();

  const valorParcela = (valor / parseInt(formaPagamento.parcelas)).toFixed(2);

  const handleClick = () => {
    onClick?.({
      title: formaPagamento.descricao,
      parcela: formaPagamento.parcelas,
      valorParcela,
    });
  };

  return (
    <ListItem button divider onClick={handleClick}>
      <div className={classes.listContentContainer}>
        <ListItemAvatar>
          <Avatar>
            <CreditCardIcon />
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={formaPagamento.descricao}
          secondary={
            <span>
              <strong>R$ {formaPagamento.parcelas}x</strong> R$
              {valorParcela}
            </span>
          }
        />
      </div>
      <ListItemAvatar>
        <Avatar className={classes.arrowIcon}>
          <ArrowIcon />
        </Avatar>
      </ListItemAvatar>
    </ListItem>
  );
};

PaymentItem.propTypes = {
  formaPagamento: PropTypes.shape({
    descricao: PropTypes.string,
    parcelas: PropTypes.number,
  }).isRequired,
  valor: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default PaymentItem;
